import React from "react"
import {Container, Grid} from "@mui/material";


interface Props {
    id?: string
    width?: string
    background?: string
    children?: JSX.Element | JSX.Element[];
    border?: boolean
    marginTop?: number
    marginBottom?: number
    boxShadow?: string
    withMobilePadding?: boolean
    sx?: any
    gridContainerMaxWidth?: string
    dataCypress?: string
}

function CCOContainer(props: Props) {

    let cols = props.width === "full" ? 12 : (props.width === "large" ? 10 : (props.width === "small" ? 6 : 8))
    let spacecols = props.width === "full" ? 0 : (props.width === "large" ? 1 : (props.width === "small" ? 3 : 2))


    return <Container data-cypress={props.dataCypress} id={props.id} sx={{
        backgroundColor: props.background === 'grey'
            ? 'var(--background-grey)'
            : props.background ? props.background : '',
        width: "100%",
        borderBottom: props.border ? '1px solid #e0e0e0' : 'none',
        borderTop: props.border ? '1px solid #e0e0e0' : 'none',
        boxShadow: props.boxShadow ? props.boxShadow : '',
        mx: 0,
        marginBottom: props.marginBottom ? props.marginBottom : 0,
        marginTop: props.marginTop ? props.marginTop : 0,
        padding: props.withMobilePadding ? {
            xs: '0 16px', sm: '0 24px', md: 'auto'
        } : '0 !important',
        ...props.sx,
    }} maxWidth={false}>
        <Grid container width={'100%!important'} maxWidth={props.gridContainerMaxWidth || 'xl'}
              sx={{
                  m: 'auto',
              }}>
            <Grid item sm={0} md={spacecols} width={'100%!important'}></Grid>
            <Grid item sm={12} md={cols} width={'100%!important'}
                  sx={{
                      // styles for correctly displaying RichText elements
                      '> div > ul, > div > ol': {marginBottom: 6},
                      '> div > blockquote + p.small-text, > div > blockquote + p.copy-quote, > div > blockquote + div.small-text, > div > blockquote + div.copy-quote, > div > blockquote > div > span > div.copy-quote, > div > blockquote > div > span > div.small-text':
                          {
                              textAlign: 'center',
                              color: 'text.primary'
                          },

                  }}>
                {props.children}
            </Grid>
            <Grid item sm={0} md={spacecols} width={'100%!important'}></Grid>
        </Grid>
    </Container>
}


export default CCOContainer